module.exports = __webpack_public_path__ + "img/logo.dark.96cf0dd5.png";